<template>
    <div class="container">
      <div class="title"><img src="img/img_title.svg"></div>
      <div class="login-card">
        <form @submit.prevent="handleSubmit">
          <div class="icon"><img src="img/img_logo_vertical.svg"></div>
          <h3 class="login-title">Born with Luxury, Shining like Stars.</h3>
          <button class="btn btn-block btn-primary">LOGIN</button>
        </form>
      </div>
    </div>
</template>

<script>

export default {
  name: 'Login',
  data: () => ({
    account: '',
    password: '',
    submitted: false,
    isLoging: false,
    isError: false,
    errorMsg: '',
    fillEmail: false
  }),
  methods: {
   handleSubmit () {
      this.submitted = true
      this.$store.dispatch('loginAuth')
    }
  }
}
</script>
